import { FsessionService } from 'src/app/servicios/session/fsession.service';
import { MunicipalityTokenService } from 'src/app/servicios/municipality-token/municipality-token.service';
import { TokenRefreshService } from 'src/app/servicios/municipality-token/token-refresh.service';

/**
 * Actualiza los tokens en el FsessionService y programa el refresco del token según la acción especificada.
 * @param fsessionService servicio para manejar la sesión y almacenamiento de tokens.
 * @param municipalityTokenService servicio para manejar la lógica relacionada con el token del municipio.
 * @param tokenRefreshService servicio para manejar el refresco automático del token.
 * @param accessToken token de acceso que se va a almacenar y usar para autenticación.
 * @param refreshToken token de refresco que se va a almacenar para futuras renovaciones del token de acceso.
 * @param actionRefresh valor que indica si se debe iniciar el refresco automático del token ('start') o solo programarlo ('schedule').
 */
export function updateTokensAndRefresh(
  fsessionService: FsessionService,
  municipalityTokenService: MunicipalityTokenService,
  tokenRefreshService: TokenRefreshService,
  accessToken: string,
  refreshToken: string,
  actionRefresh: 'start' | 'schedule'
) {
  fsessionService.agregarActualizar("clientToken", accessToken, "municipality");
  fsessionService.agregarActualizar("refreshToken", refreshToken, "municipality");
  const tokenExpiration = municipalityTokenService.getTokenExpiration(accessToken);
  fsessionService.agregarActualizar("AccessTokenExp", String(tokenExpiration), "municipality");
  actionRefresh === 'start' ? tokenRefreshService.start() : tokenRefreshService.scheduleRefresh();
}